module.exports = __webpack_public_path__ + "img/firefox.5e6cf92c.svg";